module.exports = __webpack_public_path__ + "static/media/S_Q.8f5ee094.png";